module.exports = __webpack_public_path__ + "img/core-active-2.1f0773a.svg";